import React from 'react';
import _ from 'lodash';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
// eslint-disable-next-line max-len
import type { ProductSpecificationDetails as IProductSpecificationDetails } from '../../../../.storyblok/types/255103/storyblok-components';
interface ProductSpecificationDetailsProps {
  blok: IProductSpecificationDetails;
}

const ProductSpecificationDetails = ({ blok }: ProductSpecificationDetailsProps) => {
  const specificationDetails = _.get(blok, 'details', []);

  return (
    <div
      className="w-full flex flex-col flex-nowrap gap-y-3 typography-body-s sm:typography-body-m !text-navy-600
        !font-utopiaStdCaption"
      {...storyblokEditable(blok)}
    >
      {specificationDetails.map((specificationDetail) => {
        return <StoryblokComponent key={specificationDetail._uid} blok={specificationDetail ?? {}} />;
      })}
    </div>
  );
};

export default ProductSpecificationDetails;
